import { defineMessages } from 'react-intl-next';

export default defineMessages({
	recommendationPreviewButtonLabel: {
		id: 'fabric.editor.ai.proactive.recommendation.preview.button.non-final',
		defaultMessage: 'Preview',
		description:
			'The preview button label which allows the user to open the preview modal and see the AI recommendation which will be applied when the user inserts',
	},
	recommendationReplaceButtonLabel: {
		id: 'fabric.editor.ai.proactive.recommendation.replace.button.non-final',
		defaultMessage: 'Replace',
		description:
			'The replace button label, when clicked the AI recommendation which immediately be inserted',
	},
	recommendationDismissButtonLabel: {
		id: 'fabric.editor.ai.proactive.recommendation.dismiss.button.non-final',
		defaultMessage: 'Dismiss',
		description:
			'The dismiss button label,when clicked the AI recommendation will be removed from the list and no longer displayed to the user',
	},
	spellingAndGrammarLabel: {
		id: 'fabric.editor.ai.proactive.spellingAndGrammar.label.non-final',
		defaultMessage: 'Spelling and grammar',
		description:
			'The label displayed in the context panel on the spelling and grammar item which display the total spelling and grammar issues found',
	},
	suggestionsTitle: {
		id: 'fabric.editor.ai.proactive.suggestions.title.non-final',
		defaultMessage: 'Suggestions',
		description:
			'The title displayed at the top of the context panel for all recommendations displayed',
	},
	moreActionsLabel: {
		id: 'fabric.editor.ai.proactive.moreActions.label.non-final',
		defaultMessage: 'More actions',
		description: 'This is the text applied to the More icon button label',
	},
	closeButtonLabel: {
		id: 'fabric.editor.ai.proactive.close.label.non-final',
		defaultMessage: 'Close',
		description: 'This is the text applied to the Close icon button label',
	},
	betaLabel: {
		id: 'fabric.editor.ai.proactive.beta.label.non-final',
		defaultMessage: 'BETA',
		description:
			'This is a lozenge displayed in the suggested edits header to signify that this is a beta feature',
	},
	moreMenuLabel: {
		id: 'fabric.editor.ai.proactive.moreMenu.label.non-final',
		defaultMessage: 'more',
		description:
			'This is the message displayed tooltip in the more menu dropdown in the context panel',
	},
	moreMenuGiveFeedback: {
		id: 'fabric.editor.ai.proactive.moreMenu.giveFeedback.non-final',
		defaultMessage: 'Give feedback',
		description:
			'This is the message displayed in the more menu dropdown in the context panel to allow the user to give feedback on the suggestions',
	},
	moreMenuManageSuggestions: {
		id: 'fabric.editor.ai.proactive.moreMenu.manageSuggestions.non-final',
		defaultMessage: 'Manage Suggestions',
		description:
			'This is the message displayed in the more menu dropdown in the context panel to allow the user to manage suggestions on the suggestions',
	},
	reloadSuggestionsButtonLabel: {
		id: 'fabric.editor.ai.proactive.reloadSuggestionsButtonLabel.non-final',
		defaultMessage: 'View past suggestions',
		description:
			'This is the button label to reload suggestions when a user has dismised all recommendations.',
	},
	askAIButtonLabel: {
		id: 'fabric.editor.ai.proactive.askAIButtonLabel.non-final',
		defaultMessage: 'Ask AI',
		description: 'This is the button label to open the AI modal.',
	},
	reloadSuggestionsStateTitle: {
		id: 'fabric.editor.ai.proactive.reloadSuggestionsState.title.non-final',
		defaultMessage: 'Your content’s looking good',
		description:
			'This is the title of the message displayed in the suggested edits panel when there are new recommendations left after a user has dismissed them all.',
	},
	reloadSuggestionsStateDescription: {
		id: 'fabric.editor.ai.proactive.reloadSuggestionsState.description.non-final',
		defaultMessage: 'Any new suggestions will appear here.',
		description:
			'This is the message displayed in the suggested edits panel when there are no new recommendations left after a user has dismissed them all.',
	},
	noSuggestionsStateTitle: {
		id: 'fabric.editor.ai.proactive.noSuggestionsState.title.non-final',
		defaultMessage: 'Suggestions will appear here',
		description:
			'This is the title of the message displayed in the suggested edits panel when there are no recommendations available.',
	},
	noSuggestionsStateDescription: {
		id: 'fabric.editor.ai.proactive.noSuggestionsState.description.non-final',
		defaultMessage:
			'You can also ask AI to improve your page with requests such as <i>Add a table of contents</i> or <i>Create headings</i>.',
		description:
			'This is the message displayed in the suggested edits panel when there are no recommendations available',
	},
	findingSuggestionsLoadingLabel: {
		id: 'fabric.editor.ai.proactive.findingSuggestionsLoadingLabel.non-final',
		defaultMessage: 'Finding suggestions',
		description: 'This is the label under the loading spinner when suggestions are being reloaded.',
	},
	enableSuggestionsStateTitle: {
		id: 'fabric.editor.ai.proactive.enableSuggestionsState.title.non-final',
		defaultMessage: 'You create. We polish.',
		description:
			'This is the title of the message displayed in the suggested edits panel when suggestions are disabled.',
	},
	enableSuggestionsStateDescription: {
		id: 'fabric.editor.ai.proactive.enableSuggestionsState.description.non-final',
		defaultMessage: 'Turn on suggested edits to quickly preview content improvements.',
		description:
			'This is the message displayed in the suggested edits panel when suggestions are disabled.',
	},
	enableSuggestionsButtonLabel: {
		id: 'fabric.editor.ai.proactive.enableSuggestionsButtonLabel.non-final',
		defaultMessage: 'Turn on',
		description:
			'This is the button label in the suggested edits panel when suggestions are disabled.',
	},
	findingSuggestionsLabel: {
		id: 'fabric.editor.ai.proactive.findingSuggestionsLabel.non-final',
		defaultMessage: 'Finding suggestions',
		description:
			'The label next to the spinner which indicates recommendations are being requested.',
	},
	findingMoreSuggestionsLoadingLabel: {
		id: 'fabric.editor.ai.proactive.findingMoreSuggestionsLoadingLabel.non-final',
		defaultMessage: 'Finding more suggestions',
		description:
			'The label next to the spinner which indicates more recommendations are being requested.',
	},
});
